export var TooltipTriggerMode;
(function (TooltipTriggerMode) {
    TooltipTriggerMode["Hover"] = "hover";
    TooltipTriggerMode["Click"] = "click";
})(TooltipTriggerMode || (TooltipTriggerMode = {}));
